// extracted by mini-css-extract-plugin
export var label = "_bk-1";
export var reminder = "_bk-0";